import { BAN_USER_IP } from 'root/src/shared/descriptions/endpoints/endpointIds'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import clearForm from 'root/src/client/logic/form/actions/clearForm'

export default (formData, { moduleKey, moduleId }) => async (dispatch) => {
	const { error } = await dispatch(apiRequest(BAN_USER_IP, formData))
	if (error) {
		throw { error: error.message }
	}
	return dispatch(clearForm({ moduleId, moduleKey }))
}
